<template>
  <div>
    <!-- NOTE: fileIsReadOnly and locked both do the same thing. -->

    <form
      class="box has-advanced-upload"
      v-bind:class="{ 'is-dragover': fileDrag }"
      method="post"
      action
      enctype="multipart/form-data"
      ref="dropzoneBox"
    >
      <div class="box__input text-center">
        <label
          v-if="
            !fileNewlyInputted &&
              !fileInfo.fileUrl &&
              !fileInfo.fileIsReadOnly &&
              !locked
          "
          style="margin:60px 10px;"
        >
          <input
            class="box__file"
            type="file"
            ref="file"
            v-bind:accept="accept"
            v-bind:disabled="locked || fileInfo.fileIsReadOnly"
          />
          <strong>
            <a style="color:#7BC5A6; cursor:pointer;">Choose a file</a>
          </strong>
          <span class="box__dragndrop"> or drag it here</span>
        </label>

        <div v-if="!fileInfo.fileUrl && (fileInfo.fileIsReadOnly || locked)">
          No File Uploaded
        </div>

        <div v-show="fileNewlyInputted">
          <img
            v-if="fileInfo.fileIsImage"
            class="img-responsive"
            ref="newimage"
            src
            alt="uploaded image"
            style="padding:10px;"
          />
          <div v-show="!fileInfo.fileIsImage">
            <div class="upload-success">
              <i class="fa fa-file-text-o"></i>
              File: {{ fileNewlyInputted }}
            </div>
          </div>
        </div>

        <div v-if="fileInfo.fileUrl">
          <div v-show="fileAlreadyUploaded">
            <img
              v-if="fileInfo.fileIsImage"
              class="img-responsive"
              v-bind:src="fileInfo.fileUrl"
              alt="uploaded image"
              style="padding:10px;"
            />
            <div v-if="!fileInfo.fileIsImage">File Uploaded</div>
          </div>

          <a
            v-show="!confirmRemove"
            type="button"
            class="viva-btn viva-btn-green"
            style="margin:5px"
            v-bind:href="fileInfo.fileUrl"
            >Download this file</a
          >

          <button
            v-if="!fileInfo.fileIsReadOnly && !locked"
            v-show="!confirmRemove"
            type="button"
            class="viva-btn viva-btn-orange"
            v-on:click="confirmRemove = true"
            style="margin:5px"
          >
            Remove this file
          </button>
          <div v-show="confirmRemove">
            Are you sure you want to remove this file?
            <button
              type="button"
              class="viva-btn viva-btn-green"
              v-on:click="confirmRemove = false"
              style="margin:5px"
            >
              No
            </button>
            <button
              type="button"
              class="viva-btn viva-btn-orange"
              v-on:click="removeSelectedFile"
              style="margin:5px"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    fileInfo: Object,
    accept: {
      required: false,
      default: "*"
    },
    locked: {
      required: false,
      default: false
    }
  },

  watch: {
    fileInfo: {
      handler: function() {
        if (this.fileInfo.fileUrl == "reset") {
          this.removeSelectedFile();
          return;
        }

        // this is also intended to look for external changes to fileUrl
        if (this.fileInfo.fileUrl) {
          this.fileAlreadyUploaded = true;
          this.fileNewlyInputted = false; // I think?
          $(this.$refs.dropzoneBox).off(
            "dragover dragenter dragleave dragend drop"
          );
          $(this.$refs.file).off("change");
        } else {
          this.fileAlreadyUploaded = false;
          this.fileNewlyInputted = false;
          this.confirmRemove = false;
          $(this.$refs.newimage).attr("src", "");
          this.$emit("fileurlchange", {
            fileInfo: this.fileInfo,
            fileData: null,
            file: null
          });
          this.acceptFile();
        }
      },
      deep: true
    }
  },

  data: function() {
    return {
      confirmRemove: false,
      fileDrag: false,
      fileAlreadyUploaded: false,
      fileNewlyInputted: false
    };
  },

  mounted: function() {
    var that = this;

    $(document).on(
      "drag dragstart dragend dragover dragenter dragleave drop",
      function(e) {
        e.preventDefault();
        e.stopPropagation();
      }
    );

    // use fileInfo.fileUrl as a direct proxy for whether or not a file exists.
    if (that.fileInfo.fileUrl) {
      that.fileAlreadyUploaded = true;
    } else {
      if (!that.locked && !that.fileInfo.fileIsReadOnly) {
        that.acceptFile();
      }
    }
  },

  methods: {
    removeSelectedFile: function(event) {
      this.fileInfo.fileUrl = null; // this triggers the watch above, which does the mechanics of removing the file
    },

    acceptFile: function() {
      var that = this;

      $(that.$refs.dropzoneBox)
        .on("dragover dragenter", function() {
          that.fileDrag = true;
        })
        .on("dragleave dragend drop", function() {
          that.fileDrag = false;
        })
        .on("drop", function(e) {
          that.processSelectedFile(e.originalEvent.dataTransfer.files[0]);
        });

      setTimeout(function() {
        // because the existance of this element is conditional on a v-if, wait for the DOM to render before setting the event listener again
        $(that.$refs.file).on("change", function(e) {
          that.processSelectedFile($(that.$refs.file)[0].files[0]);
        });
      });
    },

    processSelectedFile: function(file) {
      var that = this;

      if (that.fileInfo.fileIsImage) {
        if (!file.type.match("image/.*")) {
          that.$emit("fileurlchange", {
            error: "Please upload an image in JPG or JPEG format!"
          });
          return;
        }
      }

      var valid_format = false;
      var format_messages = [];
      console.log(file.type);
      that.accept.split(",").forEach(function(accept) {
        if (accept == "callrecorder") {
          var tmp = file.name.split(".");
          if (!tmp[tmp.length - 1].match("zip")) {
            format_messages.push("callrecorder");
          } else {
            valid_format = true;
          }
        }
        if (!file.type.match(accept.replace("*", ".*"))) {
          switch (accept) {
            case "application/pdf":
              format_messages.push("PDF");
              break;
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
              format_messages.push("DOCX");
              break;
            case "application/msword":
              format_messages.push("DOC");
              break;
            case "video/mp4":
              format_messages.push("MP4");
              break;
            case "video/quicktime":
              format_messages.push("MOV");
              break;
            case "video/*":
              format_messages.push("MOV or MP4");
              break;
            case "image/png":
              format_messages.push("PNG");
              break;
            case "image/jpeg":
              format_messages.push("JPEG");
              break;
            case "*":
              format_messages.push("any");
              break;
            default:
              format_messages.push(accept);
              break;
          }
        } else {
          valid_format = true;
        }
      });

      if (!valid_format) {
        that.$emit("fileurlchange", {
          error:
            "Please upload a file in " +
            format_messages.join(" or ") +
            " format!"
        });
        return;
      }

      that.fileNewlyInputted = file.name;

      $(that.$refs.dropzoneBox).off(
        "dragover dragenter dragleave dragend drop"
      );
      $(that.$refs.file).off("change");

      var fileData = new FormData();
      if (file) {
        fileData.append("attachment", file);

        if (that.fileInfo.fileIsImage) {
          var reader = new FileReader();
          reader.onload = function(e) {
            $(that.$refs.newimage).attr("src", e.target.result);
          };
          reader.readAsDataURL(file);
        } else {
          // some other indication that the file is being processed?
        }

        // emit to the parent that the file has been updated
        that.$emit("fileurlchange", {
          fileInfo: that.fileInfo,
          fileData: fileData,
          file: file
        });
        console.log("emitted fileurlchange");
      }
    }
  }
};
</script>

<style scoped>
/* Import Viva colors */
@import '../styles/viva-classes.css';


/* support drag-and-drop file uploads */
.box__dragndrop,
.box__uploading,
.box__success,
.box__error {
  display: none;
}

.box.has-advanced-upload {
  background-color: var(--viva-cream);
  outline: 2px dashed var(--viva-green);
  outline-offset: -10px;
}
.box.has-advanced-upload .box__dragndrop {
  display: inline;
}

.box.is-dragover {
  background-color: $lightgrey;
  outline-color: var(--viva-orange);
}

.box.is-uploading .box__input {
  visibility: none;
}
.box.is-uploading .box__uploading {
  display: block;
}

.box__button {
  display: none;
}

.box {
  font-size: 1.5rem; /* 20 */
  background-color: var(--viva-cream);
  position: relative;
  padding:25px 10px;
  border-radius: 10px;
}
.box.has-advanced-upload {
  outline: 2px dashed var(--viva-green);
  outline-offset: -10px;

  -webkit-transition: outline-offset 0.15s ease-in-out,
    background-color 0.15s linear;
  transition: outline-offset 0.15s ease-in-out, background-color 0.15s linear;
}
.box.is-dragover {
  outline-offset: -20px;
  outline-color: var(--viva-orange);
  background-color: #fff;
}
.box__dragndrop,
.box__icon {
  display: none;
}
.box.has-advanced-upload .box__dragndrop {
  display: inline;
}
.box.has-advanced-upload .box__icon {
  width: 100%;
  height: 80px;
  fill: var(--viva-green);
  display: block;
  margin-bottom: 40px;
}

.box.is-uploading .box__input,
.box.is-success .box__input,
.box.is-error .box__input {
  visibility: hidden;
}

.box__uploading,
.box__success,
.box__error {
  display: none;
}
.box.is-uploading .box__uploading,
.box.is-success .box__success,
.box.is-error .box__error {
  display: block;
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;

  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.box__uploading {
  font-style: italic;
}
.box__success {
  -webkit-animation: appear-from-inside 0.25s ease-in-out;
  animation: appear-from-inside 0.25s ease-in-out;
}
@-webkit-keyframes appear-from-inside {
  from {
    -webkit-transform: translateY(-50%) scale(0);
  }
  75% {
    -webkit-transform: translateY(-50%) scale(1.1);
  }
  to {
    -webkit-transform: translateY(-50%) scale(1);
  }
}
@keyframes appear-from-inside {
  from {
    transform: translateY(-50%) scale(0);
  }
  75% {
    transform: translateY(-50%) scale(1.1);
  }
  to {
    transform: translateY(-50%) scale(1);
  }
}

.box__restart {
  font-weight: 700;
}
.box__restart:focus,
.box__restart:hover {
  color: var(--viva-green);
}

.box__file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.box__file + label {
  max-width: 80%;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
}
.box__file + label:hover strong,
.box__file:focus + label strong,
.box__file.has-focus + label strong {
  color: var(--viva-orange);
}
.box__file:focus + label,
.box__file.has-focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}
.box__file + label * {
  /* pointer-events: none; */ /* in case of FastClick lib use */
}

.box__button {
  font-weight: 700;
  color: #e5edf1;
  background-color: var(--viva-green);
  display: none;
  padding: 8px 16px;
  margin: 40px auto 0;
}
.box__button:hover,
.box__button:focus {
  background-color: var(--viva-orange);
}

.upload-success {
  padding: 15px;
  background-color: var(--viva-cream);
  margin: 10px 0;
  font-weight: 500;
  font-size: 1.5rem;
}

.upload-success i {
  color: var(--viva-green);
  font-size: 24px;
  margin-right: 10px;
}
</style>